//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "ProductTab",
  props: ["value", "create"],
  components: {},
  mounted: async function () {
    let responseHL = await BackendServices.getProductHierarchyLevels();
    this.hierarchyLevels = responseHL.data;
    this.classificationIndex =
      this.hierarchyLevels.map((i) => i.id).indexOf(this.value.level_id) + 1;

    this.classificationParent = this.hierarchyLevels
      .filter((i) => i.id === this.value.level_id)
      .pop().parent_id;

    if (this.classificationParent) {
      let responseHLE = await BackendServices.getProductHierarchyLevelElements(
        this.classificationParent
      );
      this.hierarchyLevelElements = responseHLE.data;
    }

    this.validateData();
    // BackendServices.getProductHierarchyLevels().then(({ data }) => {
    //   this.hierarchyLevels = data;

    //   this.classificationIndex =
    //     this.hierarchyLevels.map((i) => i.id).indexOf(this.value.level_id) + 1;
    //   this.classificationParent = this.hierarchyLevels
    //     .filter((i) => i.id === this.value.level_id)
    //     .pop().parent_id;

    //   if (this.value.level.parent_id) {
    //     BackendServices.getProductHierarchyLevelElements(
    //       this.value.level.parent_id
    //     ).then((response) => {
    //       this.hierarchyLevelElements = response.data;
    //     });
    //   }
    // });

    // this.validateData();
  },
  data: function () {
    return {
      validForm: false,
      classificationParent: null,
      classificationIndex: null,
      hierarchyLevels: [],
      hierarchyLevelElements: [],
    };
  },
  computed: {
    classificationParentName: function () {
      let classificationParent = this.hierarchyLevels
        .filter((i) => i.id === this.classificationParent)
        .pop();

      return classificationParent ? classificationParent.name : "N/A";
    },
  },
  methods: {
    required,
    noValidation,
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    setClassificationLevel(event) {
      let item = this.hierarchyLevels[event - 1];
      this.value.level_id = item.id;
      this.setParentId(item.id);
    },
    setParentId(event) {
      this.classificationIndex =
        this.hierarchyLevels.map((i) => i.id).indexOf(event) + 1;
      this.classificationParent = this.hierarchyLevels
        .filter((i) => i.id === event)
        .pop().parent_id;

      this.value.parent_id = null;

      this.updateData();
    },
    updateData() {
      this.$emit("input", this.value);
    },
  },
  watch: {
    value: {
      deep: true,
      handler: async function () {
        this.classificationIndex =
          this.hierarchyLevels.map((i) => i.id).indexOf(this.value.level_id) +
          1;
        this.classificationParent = this.hierarchyLevels
          .filter((i) => i.id === this.value.level_id)
          .pop().parent_id;

        if (this.classificationParent) {
          let responseHLE =
            await BackendServices.getProductHierarchyLevelElements(
              this.classificationParent
            );
          this.hierarchyLevelElements = responseHLE.data;
        } else {
          this.hierarchyLevelElements = [];
        }
      },
    },
  },
};
